// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_UDN","cls2":"AutoCompleteResultRow-cls2_Uyt AutoCompleteResultRow-cls1_UDN"};